import { v4 as uuid } from 'uuid';
/*
 * be set when initAsOauth happened
 */
export default function setTranslations (translations) {
    this.translations = translations;
    this.injectDefaults();
    this.observed.translations = uuid();
}
